import splashImage from '../images/splash.png';

function Intro({ onPlay, onNewCharacter }) {
  return (
    <main className="intro-screen" style={{ backgroundImage: `url(${splashImage})` }}>
      <div className="intro-action-row" aria-label="Adenrel mode selection">
        <button type="button" className="intro-action-button" onClick={onPlay}>
          Play
        </button>
        <button type="button" className="intro-action-button" onClick={onNewCharacter}>
          New Character
        </button>
      </div>
    </main>
  );
}

export default Intro;
